import React, { PureComponent } from 'react'
import { withRouter } from "react-router-dom";
import { Nav, Collapse } from 'reactstrap';
import { SidebarItem } from '../Basicos/index';
import { FaBars } from 'react-icons/fa';
import { connect } from 'react-redux'
import * as actionsRedux from '../Store/Actions/index'
import { Scrollbars } from "react-custom-scrollbars";
import logoChristus from '../images/logo_universidade_christus.png';
import logoChristusInvertido from '../images/logo_universidade_christus_invertido.png';


function Sidebar(props) {
    return (
        <div
            className={`sidebar navbar-header ${props.sidebarAtivo ? 'active' : ''}`}
            onMouseLeave={props.ativarSidebar}
            onMouseEnter={props.ativarSidebar}
        >
            <Scrollbars
                autoHide
                autoHideTimeout={1000}
                autoHideDuration={200}
                autoHeight
                autoHeightMin={props.modoMobile && !props.sidebarAtivo ? '75px' : '100vh'}
                autoHeightMax={'100vh'}
            >
                <p className="h4 logoSB navbar-light">
                    <img src={props.sidebarAtivo ? logoChristusInvertido : logoChristus} />

                    {props.modoMobile && (
                        <FaBars
                            color="white"
                            size="30px"
                            onClick={props.ativarSidebar}
                            className='icon-menusidebar'
                        />
                    )}
                </p>
                <Collapse isOpen={(props.sidebarAtivo || !props.modoMobile)} navbar>
                    <Nav className="flex-column">
                        {
                            props.sidebarAtivo ?
                                (function () {
                                    const nomeSocial = localStorage.getItem('nome_social');
                                    const nomeCivil = localStorage.getItem('nome');
                                    const nomeExibicao = (nomeSocial && nomeSocial !== "null" && nomeSocial !== "") ? nomeSocial : nomeCivil;

                                    return (
                                        <div className="flex-column nome-usuario-submenu mb-2">
                                            <h5>{nomeExibicao ? nomeExibicao.charAt(0).toUpperCase() + nomeExibicao.slice(1) : ""}</h5>
                                        </div>
                                    );
                                })() : ""
                        }
                        {props.funcionalidades.map(elemento => (
                            <SidebarItem
                                {...elemento}
                                onClick={props.ativarSidebar}
                                sidebarAtivo={props.sidebarAtivo}
                                key={elemento.descricao}
                            />
                        ))}
                        <SidebarItem
                            url={"/sair"}
                            onClick={props.ativarSidebar}
                            logout={props.logout}
                            sidebarAtivo={props.sidebarAtivo}
                            descricao={"Sair"}
                        />
                    </Nav>
                </Collapse>
            </Scrollbars>
        </div>
    );
}

const mapDispatchToProps = (dispatch) => {
    return {
        logout: () => dispatch(actionsRedux.logout()),
        ativarSidebar: (evento) => dispatch(actionsRedux.ativarSidebar(evento)),
    }
};

const mapStateToProps = (state) => ({
    modoMobile: state.core.modoMobile,
    sidebarAtivo: state.core.sidebarAtivo,
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Sidebar));

